/* eslint-disable react/prop-types */
import * as React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'

import theme from '../../src/components/themes/main/index'

export default ({ element }) => <ThemeProvider theme={theme}>{element}</ThemeProvider>
